import * as math from 'mathjs';

// Vos modifications de mathjs
const originalToTex = math.Node.prototype.toTex;
math.Node.prototype.toTex = function () {
    const originalOutput = originalToTex.call(this);
    let newOutput = originalOutput.replace(/\\cdot/g, '\\times');
    return newOutput;
};

math.simplify.rules.push({
    l: 'n+-n1/n2',
    r: 'n-n1/n2',
});
math.simplify.rules.push({
    l: 'n*n1',
    r: 'n n1',
});

export default math;
